import React from 'react';
import PropTypes from 'prop-types';
import Popover from '@glu/popover-react';
import { withStyles } from '@glu/theming';
import { InfoCircleNextIcon } from '@glu/icons-react';

import styles from './Popover.styles';

const BrandingPopover = ({ classes, children }) => (children ? (
  <Popover content={children}>
    <div className={classes.root}>
      <InfoCircleNextIcon />
    </div>
  </Popover>
) : null);

BrandingPopover.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired
};

export default withStyles(styles)(BrandingPopover);
